// schema
import { IFlowState, IOrg, IUser, IViewer } from "@schema";

// libraries
import { Environment } from "relay-runtime";
import { WithStyles } from "@material-ui/core/styles/withStyles";
import { RelayRefetchProp } from "react-relay";

// state
import { setOnboardingLoaded } from "@actions/onboarding.actions";
import { setActiveViewFeed } from "@actions/chrome-extension.actions";

// internal
import { navItems } from "./OnboardingNUX.util";
import { styles } from "./OnboardingNUX.styles";

export { OnboardingStep } from "@clockwise/web-commons/src/util/onboarding.util";

export type OnboardingNUXMode = "dialog" | "fixed";

export enum OnboardingType {
  Default = "Default",
  Links = "Links",
  ManagerSegmentation = "ManagerSegmentation",
  FocusTimeSyncAndLunchHoldStep = "FocusTimeSyncAndLunchHoldStep",
}

export enum OnboardingTypeSource {
  JtbdSurvey = "jtbd-survey",
  LinksLandingPage = "links-landing-page",
  WelcomeLoginPage = "welcome-login-page",
  Survey = "survey",
}

export type NavItem = typeof navItems[0];

export interface NavigationOptions {
  save?: () => Promise<void>;
  hasError?: boolean;
}

export interface OnboardingMeta {
  onboardingType: OnboardingType;
  onboardingTypeSource: OnboardingTypeSource | null; // the reason why the current onboarding type is the way it is
}

export interface OnboardingStepProps {
  goForward: () => void;
  goBack: () => void;
  goTo: (step: OnboardingStep) => void;
  currentStep: OnboardingStep;
  environment: Environment;
  org: IOrg;
  user: IUser;
  viewer: IViewer;
  lockedStepMap: Record<OnboardingStep, boolean>;
  skipableStepMap: Record<OnboardingStep, boolean>;
  unlockStep: (step: OnboardingStep) => void;
  skipStep: (step: OnboardingStep, skip?: boolean, callback?: () => void) => void;
  showBanner: (bannerMessage: string) => void;
  cameFromPreviousSlide: boolean;
  setNavigationOptions: (navigationOptions: NavigationOptions) => void;
  hasErrors: boolean;
  refetch: () => Promise<void>;
  onboardingMeta: OnboardingMeta;
}

export interface IContainer {
  viewer: IViewer;
  relay: RelayRefetchProp;
  onboardingState: IFlowState;
  onRequestClose: () => void;
  mode?: OnboardingNUXMode;
}

export interface IProps extends IContainer, WithStyles<typeof styles> {
  setOnboardingLoaded: typeof setOnboardingLoaded;
  setActiveViewFeed: typeof setActiveViewFeed;
  fastCrawlUserCrawledRefetchComplete: boolean;
  fastCrawlTeammatesIdentifiedRefetchComplete: boolean;
  fastCrawlFatalState: boolean;
  isChromeExtension: boolean;
  partnerLogo: "asana" | "";
  onboardingMeta: OnboardingMeta;
}

export interface IState {
  currentStep: OnboardingStep;
  lockedStepMap: Record<OnboardingStep, boolean>;
  skipableStepMap: Record<OnboardingStep, boolean>;
  bannerMessage: string;
  showBanner: boolean;
  cameFromPreviousSlide: boolean;
  hasErrors: boolean;
  save: () => Promise<void>;
  steps: OnboardingStep[];
  onboardingMeta: OnboardingMeta;
}
